module.exports = __webpack_public_path__ + "img/73.cbcbc7d2.jpg";